function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import regeneratorRuntime from "regenerator-runtime";
import { defineComponent, reactive, onMounted, watch, toRefs, ref, getCurrentInstance } from "vue";
import searchMixin from "@/mixin/search";
import SearchBar from "@/components/SearchV3/index.vue";
import TableList from "@/components/TableList/index.vue";
import TableFromMpdel from "./from";
import { deleteTemplateConfirm, noSupportedDelete } from "./index";
import Pagination from "@/components/Pagination/index.vue";
import BatchModular from "./components/batch-modular.vue";
import { getTemplateList, updateTemplate } from "@/api/veditor/index";
import { handleViewProject } from "@/views/repository/resource/config/methods";
import ImageContainer from "@/views/creative/components/image-container.vue";
import PreviewDialog from "@/views/producer/video-template/components/preview-dialog.vue";
import EditDialog from "@/views/producer/video-template/components/edit-dialog.vue";
import { filterEmptyObjects } from "@ve-pro/ve/aside/modular/template-modular/components/index";
import { Message } from "element-ui";
import _ from "lodash";
export default defineComponent({
    components: {
        EditDialog: EditDialog,
        SearchBar: SearchBar,
        TableList: TableList,
        Pagination: Pagination,
        BatchModular: BatchModular,
        ImageContainer: ImageContainer,
        PreviewDialog: PreviewDialog
    },
    mixins: [
        searchMixin
    ],
    setup: function setup(props) {
        var defaultCoverPreviews = function defaultCoverPreviews(s) {
            // 根据主尺寸展示相应的封面图
            if (s.cover_previews && JSON.stringify(s.cover_previews) !== "{}" && s.main_ratio) {
                if (s.cover_previews["zh-cn"] && JSON.stringify(s.cover_previews["zh-cn"]) !== "{}") {
                    return s.cover_previews["zh-cn"][s.main_ratio] || s.cover_url;
                } else if (s.cover_previews["en"] && JSON.stringify(s.cover_previews["en"]) !== "{}") {
                    return s.cover_previews["en"][s.main_ratio] || s.cover_url;
                } else if (s.cover_previews[""] && JSON.stringify(s.cover_previews[""]) !== "{}") {
                    return s.cover_previews[""][s.main_ratio] || s.cover_url;
                }
                return s.cover_url;
            }
            return s.cover_url;
        };
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var dialogVisible = ref(false);
        var editVisible = ref(false);
        var rowItem = ref();
        var checkedRow = ref([]);
        var _$ref = TableFromMpdel(), formSearchQuery = _$ref.formSearchQuery, formItemConfig = _$ref.formItemConfig, tableColumnConfig = _$ref.tableColumnConfig;
        var formItemList = reactive(formItemConfig);
        var formQuery = reactive({
            query: formSearchQuery
        });
        var accountTable = reactive({
            accountTableColumn: tableColumnConfig.value,
            accountList: [],
            accountListTotal: 0,
            listLoading: false
        });
        var videoTemplateList = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            accountTable.listLoading = true;
                            _ctx.next = 3;
                            return getTemplateList(formQuery.query);
                        case 3:
                            res = _ctx.sent;
                            accountTable.accountList = (res.data.data.list || []).map(function(s) {
                                return _objectSpreadProps(_objectSpread({}, s), {
                                    cover_previews: s.cover_previews && filterEmptyObjects(JSON.parse(s.cover_previews)) || null,
                                    previews: s.previews && filterEmptyObjects(JSON.parse(s.previews)) || null
                                });
                            });
                            // console.log(accountTable.accountList)
                            accountTable.accountListTotal = res.data.data.total;
                            accountTable.listLoading = false;
                        case 7:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function videoTemplateList() {
                return _ref.apply(this, arguments);
            };
        }();
        var handleSelectionChange = function(val) {
            checkedRow.value = val;
        };
        var handleSortChange = function(order) {
            formQuery.query.order = order.prop;
            if (order.order === "descending") {
                formQuery.query.order = "-" + order.prop;
            }
            videoTemplateList();
        };
        var handleDelete = function(ids) {
            if (noSupportedDelete(checkedRow.value)) return;
            deleteTemplateConfirm().then(_asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return updateTemplate({
                                delete_ids: Array.isArray(ids) ? ids : [
                                    ids
                                ]
                            });
                        case 2:
                            Message.success("\u64CD\u4F5C\u6210\u529F");
                            videoTemplateList();
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            })));
        };
        var handleEdit = function(row) {
            rowItem.value = row;
            editVisible.value = true;
        };
        var disabledPreview = function(row) {
            return (JSON.stringify(row.cover_previews) === "{}" || _.isNull(row.cover_previews)) && (JSON.stringify(row.previews) === "{}" || _.isNull(row.previews));
        };
        var handleViewModel = function(row) {
            rowItem.value = row;
            dialogVisible.value = true;
        };
        onMounted(function() {
            watch(function() {
                return root.$route;
            }, function() {
                videoTemplateList();
            }, {
                immediate: true
            });
        });
        return _objectSpreadProps(_objectSpread({}, toRefs(formQuery)), {
            rowItem: rowItem,
            checkedRow: checkedRow,
            accountTable: accountTable,
            formItemList: formItemList,
            editVisible: editVisible,
            dialogVisible: dialogVisible,
            handleDelete: handleDelete,
            handleEdit: handleEdit,
            defaultCoverPreviews: defaultCoverPreviews,
            videoTemplateList: videoTemplateList,
            handleSortChange: handleSortChange,
            handleViewProject: handleViewProject,
            handleViewModel: handleViewModel,
            disabledPreview: disabledPreview,
            handleSelectionChange: handleSelectionChange
        });
    }
});
